/* eslint-disable @typescript-eslint/no-var-requires */
const packageMeta = require('./package.json');
const seamlessRc = require('./../../.seamlessrc.json');

const NAME = seamlessRc.name;
const TENANT = seamlessRc.tenantId;
const pluginPath = `/${TENANT}-${NAME}/${TENANT}-${NAME}-${packageMeta.version}`;
const fileName = `${TENANT}-${NAME}`;

module.exports = {
  manifestVersion: '2.0',
  name: `${TENANT}-${NAME}`,
  version: packageMeta.version,
  config: {
    hasCss: false,
    files: {
      scripts: [
        {
          url: `${pluginPath}/${fileName}.vendors~${fileName}.min.min.js`,
          attrs: {
            type: 'module', // vendor
          },
        },
        {
          url: `${pluginPath}/${fileName}.min.js`,
          attrs: {
            type: 'module', // component
          },
        },
        {
          url: `${pluginPath}/${fileName}.vendors~${fileName}.es5.min.js`,
          attrs: {
            nomodule: '', //vendor old browsers remove its not supported
          },
        },
        {
          url: `${pluginPath}/${fileName}.es5.min.js`,
          attrs: {
            nomodule: '', //component old browsers remove its not supported
          },
        },
      ],
    },
    dependencies: {
      oneweb: '2.0',
    },
    isUserSessionRequired: false,
    integrationType: 'webcomponent',
    marketAvailability: [
      {
        language: 'de',
        country: 'DE',
      },
      {
        language: 'pt',
        country: 'PT',
      },
      {
        language: 'en',
        country: 'IN',
      },
      {
        language: 'nl',
        country: 'NL',
      },
      {
        language: 'en',
        country: 'US',
      },
    ],
  },
  aemComponentConfig: {
    title: 'Charging Time Calculator Component',
    description: packageMeta.description,
    componentGroup: 'Generic NG - Content',
    productPrefix: seamlessRc.tenantId,
    tagNameWithoutPrefix: 'ctc-frontend',
    dialog: [
      // {
      //   widgetType: 'text',
      //   defaultValue: '',
      //   label: 'vehicles',
      //   param: 'vehicles',
      //   hint: 'Preselected Vehicles comma separated, EQA 250, EQB 260',
      // },
      {
        widgetType: 'text',
        defaultValue: '',
        label: 'dataSource',
        param: 'dataSource',
        hint: 'Preselected dataSource as absolute url to fetch vehicle data from.',
        // e.g. https://nafta-service-dev.com/api/byo/v1/publish/en_us/content/eq/charging/feed/EQS
      },
      {
        widgetType: 'checkbox',
        defaultValue: false,
        label: 'asSidebar',
        param: 'asSidebar',
        hint: 'Show component as sidebar (important for correct width rendering.)',
      },
    ],
  },
};
